<template>
	<div class="topcards-grid">
		<section
			v-for="card in visibleCards"
			:key="card.key"
			class="nlp-topcards"
			@click="handleCardClick(card.key)"
		>
			<div
				:class="[
					'nlp-tc-innercontainer',
					card.bgClass,
					'fam-mont',
					'fs-13',
					'mob-fs-12',
					'fw-M',
					'color-1F1F1F',
				]"
			>
				<span class="text-center" v-html="card.label"></span>
				<img
					:src="card.icon"
					:alt="card.label"
					:class="[
						isLaptop && {
							h70w70: card.key == 'interviewprep' || card.key == 'takeasmnt',
							h70w75: card.key == 'buildresume',
							h58w70: card.key == 'learnupskill',
							h74w65: card.key == 'careerroadmap',
							h70w74: card.key == 'applyjobs',
						},
						!isLaptop &&
							['buildresume', 'interviewprep', 'takeasmnt'].includes(
								card.key
							) &&
							'mobtop3img',
						!isLaptop && card.key == 'applyjobs' && 'mobapplyimg',
					]"
				/>
			</div>
		</section>

		<InterviewPrepModal
			v-if="interviewPrepModal"
			:showMod="interviewPrepModal"
			:fromAnotherPage="true"
			@close-modal="hideModal()"
		/>
	</div>
</template>

<script>
import buildResumeIcon from "@/assets/NewDashboard/topcards/buildres.avif";
import interviewPrepIcon from "@/assets/NewDashboard/topcards/intprep.avif";
import takeAssessmentIcon from "@/assets/NewDashboard/topcards/takeases.avif";
import careerRoadmapIcon from "@/assets/NewDashboard/topcards/careerroad.avif";
import applyJobsIcon from "@/assets/NewDashboard/topcards/ajobs.avif";
import learnUpskillIcon from "@/assets/NewDashboard/topcards/lnupskill.avif";
import { config } from "@/config/index.js";
import InterviewPrepModal from "@/components/MyProfile/NoskillPrepareInterview.vue";
import { mapGetters } from "vuex";
import { trackEvent } from "@/tracking/events";
import { applyOrder } from "@/utils/applyOrder";

export default {
	components: {
		InterviewPrepModal,
	},
	props: {
		// Card keys in display order, e.g. ["applyjobs", "buildresume", ...].
		cardOrder: {
			type: Array,
			default: null,
		},
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateData: "getPrimaryCandidateInfo",
		}),
		visibleCards() {
			return applyOrder(this.cards, this.cardOrder, (card) => card.key);
		},
	},
	data() {
		return {
			isLaptop: true,
			interviewPrepModal: false,
			cards: [
				{
					key: "buildresume",
					label: "Build<br>Resume",
					bgClass: "nlp-tc-resumebuild",
					icon: buildResumeIcon,
				},
				{
					key: "interviewprep",
					label: "Interview<br>Prep",
					bgClass: "nlp-tc-interviewprep",
					icon: interviewPrepIcon,
				},
				{
					key: "takeasmnt",
					label: "Take<br>Assessment",
					bgClass: "nlp-tc-takeasmnt",
					icon: takeAssessmentIcon,
				},
				{
					key: "careerroadmap",
					label: "Career<br>Roadmap",
					bgClass: "nlp-tc-careerroadmap",
					icon: careerRoadmapIcon,
				},
				{
					key: "applyjobs",
					label: "Apply for<br>Jobs",
					bgClass: "nlp-tc-applyjobs",
					icon: applyJobsIcon,
				},
				{
					key: "learnupskill",
					label: "Learn &<br>Upskill",
					bgClass: "nlp-tc-learnupskill",
					icon: learnUpskillIcon,
				},
			],
		};
	},
	mounted() {
		this.checkScreenSize();
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1029;
		},
		handleCardClick(key) {
			const actions = {
				buildresume: this.redirectToBuilder,
				interviewprep: this.goToInterviewPrep,
				careerroadmap: this.goToInterviewPrep,
				takeasmnt: this.goToAssessment,
				applyjobs: this.goToJobs,
				learnupskill: this.goToOnlineCourses,
			};
			trackEvent("topcard_selected", {
				cardId: key,
			});
			if (actions[key]) actions[key]();
		},
		hideModal() {
			this.interviewPrepModal = false;
		},
		goToInterviewPrep() {
			const OnlySkills = this.candidateData.skills.filter(
				(link) => link.parser != true
			);
			if (OnlySkills.length > 0) {
				this.$router.push({
					name: "InterviewKickstart",
					query: { from: "home" },
				});
			} else {
				this.interviewPrepModal = true;
			}
		},
		redirectToBuilder() {
			this.$router.push({ path: "/dashboard" });
		},
		goToAssessment() {
			this.$router.push({ name: "AssessmentMarketplace" });
		},
		goToOnlineCourses() {
			window.location.href = `${config.trainingBase}/marketplace`;
		},
		goToJobs() {
			this.$router.push({ name: "JobSearch" });
		},
	},
};
</script>

<style scoped>
.nlp-topcards {
	height: 117.28px;
	background: #ffffff;
	border: 1.12772px solid #e9e9e9;
	box-shadow: 0px -2.25544px 5.63861px rgba(255, 255, 255, 0.9),
		0px 4.51089px 11.2772px rgba(0, 0, 0, 0.1);
	border-radius: 18.0435px;
	padding: 5px;
	cursor: pointer;
	touch-action: manipulation;
}

.nlp-tc-innercontainer {
	width: 100%;
	height: 100%;
	border: 1.12772px solid #f1f1f1;
	box-shadow: inset 0px 1.12772px 3.38316px rgba(0, 0, 0, 0.06);
	border-radius: 11.2772px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-between;
	padding: 8px 8px 0px 8px;
	overflow: hidden;
}
.nlp-tc-innercontainer span {
	line-height: normal;
	font-size: 13px !important;
}

.nlp-tc-resumebuild {
	background: rgba(231, 239, 252, 0.56);
}
.nlp-tc-interviewprep {
	background: rgba(252, 236, 231, 0.56);
}
.nlp-tc-takeasmnt {
	background: rgba(250, 231, 252, 0.38);
}
.nlp-tc-careerroadmap {
	background: rgba(255, 244, 205, 0.56);
}
.nlp-tc-applyjobs {
	background: rgba(241, 252, 231, 0.56);
}
.nlp-tc-learnupskill {
	background: rgba(255, 214, 214, 0.32);
}
.topcards-grid {
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	gap: 14px;
	width: 100%;
}
@media only screen and (min-width: 1029px) {
	.h70w75 {
		height: 70px;
		width: 75px;
	}
	.h70w70 {
		height: 70px;
		width: 70px;
	}
	.h74w65 {
		height: 58px;
		width: 75px;
	}
	.h70w74 {
		height: 70px;
		width: 85px;
	}
	.h58w70 {
		height: 58px;
		width: 70px;
	}
}
@media only screen and (max-width: 1028px) {
	.mobtop3img {
		height: 53px !important;
		width: 58px !important;
	}
	.mobapplyimg {
		height: 50px !important;
		width: 69px !important;
	}
	.nlp-tc-innercontainer img {
		height: 48px;
		width: 60px;
	}
	.topcards-grid {
		grid-template-columns: repeat(3, 1fr);
		gap: 10px;
	}
	.nlp-topcards {
		border-radius: 14px;
		padding: 4px;
		height: 104px;
	}
}
</style>
